import React, { useRef } from "react";

import { getIcon } from "../../../helpers/icons";
import { MediaIcon } from "../../../helpers/media";
import { limitString } from "../../../helpers/format";
import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function Card({ item = {}, size = "col4", onHover, onClick = () => { } }) {
    const itemRef = useRef(null);

    if (!item || Object.keys(item).length === 0) {
        return null;
    }

    return (
        <div
            ref={itemRef}
            className={`${style.postCard} ${style[size]} ${item.media_type ? style[item.media_type] : ''}`}
            onMouseMove={(e) => e.stopPropagation()}
            onMouseEnter={(e) => {
                e.stopPropagation();
                onHover(itemRef);
            }}
            onClick={onClick}
        >
            <Link to={`/article/${item.url}`} className={style.postCardInner}>
                <div className={style.imageWrap}>
                    <Background
                        className={style.cardImage}
                        src={item.thumbnail_image}
                        size="660x360"
                        cPosition="topRight"
                    />
                    <div className={style.textContent}>
                        <div className={style.icon}>
                            <MediaIcon type={item.media_type} />
                        </div>
                        <div className={style.bottomContent}>
                            <div className={style.title}>
                                <Title className="cardTitle" tag="h6">
                                    {limitString(item.name, 10, true)}
                                </Title>
                            </div>
                            {item.episode_number != null && (
                                <div className={style.bottomIcon}>
                                    <i className={getIcon("Episode")}></i>
                                    <Text className="size12" text={`E${item.episode_number}`} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}
